import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import SimpleCard from '../../../../../components/SimpleCard';
import { createRetailCheckoutSession } from '../../../../../core/vendor-retail/action';

export default function Payment() {
  const { id: retailProfileId } = useParams();
  const dispatch = useDispatch();
  const { vendorRetailPayload, currentBooking } = useSelector((store) => store.vendorRetail);
  const { user } = useSelector((store) => store.users);
  const { profile } = useSelector((store) => store.retailProfiles);

  const [loading, setLoading] = useState(false);

  const totalPrice = vendorRetailPayload?.totalPrice || currentBooking?.total_price || 0;
  const bookingId = vendorRetailPayload?.bookings?.[0]?.id || currentBooking?.id;

  const handlePayment = () => {
    if (!bookingId) {
      console.error('No booking ID available');
      return;
    }

    setLoading(true);

    const sessionData = {
      vendor_info: {
        name: user.name || '',
        email: user.email || '',
        phone: user.phone_number || '',
        address: {
          city: '',
          country: '',
          line1: '',
          postal_code: '',
          state: '',
        },
        description: user.vendor_business_desc || '',
        metadata: {
          vendorId: user.id,
        },
      },
      payment_info: {
        unit_amount: totalPrice,
        currency: 'usd',
      },
      metadata: {
        vendorId: user.id,
        bookingId,
        retailScheduleId:
          vendorRetailPayload.retailScheduleId || currentBooking?.retail_schedule_id,
        isFullPayment: 'true',
      },
    };

    dispatch(createRetailCheckoutSession(sessionData));
  };

  return (
    <div>
      <Grid container justifyContent="center" marginBottom={2}>
        <Grid item>
          <Typography fontWeight="bold">Complete Payment:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>Finalize your retail space booking</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <Grid container justifyContent="center" padding={4}>
          <Grid item xs={12} textAlign="center">
            <Typography variant="h6" fontWeight="bold" marginBottom={2}>
              Your application has been approved!
            </Typography>
            <Typography variant="body1" color="text.secondary" marginBottom={3}>
              Click below to complete your payment and confirm your booking.
            </Typography>

            <Typography variant="h4" fontWeight="bold" color="#EE7B57" marginBottom={3}>
              $ {totalPrice.toFixed(2)} USD
            </Typography>

            <Button
              variant="contained"
              size="large"
              onClick={handlePayment}
              disabled={loading}
              sx={{
                bgcolor: '#EE7B57',
                color: 'white',
                px: 6,
                py: 1.5,
                fontSize: '1.1rem',
                '&:hover': {
                  bgcolor: '#d66a47',
                },
              }}>
              {loading ? <CircularProgress size={24} /> : 'Proceed to Payment'}
            </Button>
          </Grid>
        </Grid>
      </SimpleCard>
    </div>
  );
}
